class Elementor_Image_info{
    static instance;

    static getInstance() {
        if (!Elementor_Image_info.instance) {
            Elementor_Image_info.instance = new Elementor_Image_info();
        }
        return Elementor_Image_info.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-image-info.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Image_info.getInstance();